module.exports = __webpack_public_path__ + "img/power-op-bg-1.3d63c330.png";